"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index15.js");require("./index16.js");const n=require("@apollo/client");var e,r=n.gql(e||(e=t.default([`
  mutation remindSeatRequest {
    remindSeatRequest {
      success
    }
  }
`])));exports.RemindSeatRequestDocument=r;
